// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__wfCUk","info":"UpdateTermsInfo_info__3cj2a"};